export default __webpack_public_path__ + "static/apple-686ae66ad58c2a43f40ce5f2618f73ba.svg";